module.exports = __webpack_public_path__ + "img/page_recargate_header.8802784c.png";